export default __webpack_public_path__ + "static/media/cyl_example.6826302a.png";